import { render } from "./quarter-charts.vue?vue&type=template&id=31ddb40a"
import script from "./quarter-charts.vue?vue&type=script&lang=ts"
export * from "./quarter-charts.vue?vue&type=script&lang=ts"
script.render = render

export default script